//****************************************
//* GRID CELL
//****************************************

(function($) {
'use strict';

$('.grid-cell').each(function() {
    var self = $(this);
    var inner = self.find('.inner');
    var backgroundUrl = inner.data('background');
    var currentBackground = inner.css('background-image');

    if (backgroundUrl) {
        inner.css('background-image', currentBackground + ', url(' + backgroundUrl + ')');
    }
});

})(jQuery);
